import { createElement, useEffect } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { RsosFavicon } from '@rsos/assets/icons';
import { useFlag } from '@rsos/flags';

// Legacy (pre-rebrand) favicon, previously served by portal_renderer.
const LEGACY_FAVICON = 'https://cdn.rapidsos.com/capstone/static/favicon.png';

// Serialize the RsosFavicon icon to an inline SVG data URI usable as a
// <link rel="icon"> href. SVGLoader wraps the <svg> in a Box, so slice out just
// the <svg>…</svg> for a valid standalone favicon.
const buildRebrandedFavicon = (): string => {
  const markup = renderToStaticMarkup(createElement(RsosFavicon));
  const svg = markup.slice(
    markup.indexOf('<svg'),
    markup.lastIndexOf('</svg>') + '</svg>'.length,
  );
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

// Owns the document favicon: the rebranded mark while `rebranded_logo` is on,
// otherwise the legacy favicon. Handled client-side so it tracks the same flag
// (including local dev `.flags` and console overrides) used by the rebranded
// logos. The server template no longer renders a favicon link, so create one if
// it isn't present yet.
const useRebrandedFavicon = () => {
  const isRebrandedLogo = useFlag('rebranded_logo');

  useEffect(() => {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel='shortcut icon']") ||
      document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.setAttribute(
      'href',
      isRebrandedLogo ? buildRebrandedFavicon() : LEGACY_FAVICON,
    );
  }, [isRebrandedLogo]);
};

export default useRebrandedFavicon;
